var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.367 7.057a7.7 7.7 0 0 1 1.73 2.542 7.9 7.9 0 0 1 .55 4.176q-.075.51-.2 1.022-.125.46-.601.575a.82.82 0 0 1-.828-.243l-9.224-9.4a.95.95 0 0 1-.288-.715q.012-.408.313-.715l1.83-1.865q.226-.23.501-.332.276-.102.552-.102.275 0 .551.115t.502.32zM12.702 20.8q-3.334 0-5.678-2.362t-2.343-5.709q0-1.303.4-2.503.402-1.2 1.204-2.3L2.775 4.35a.98.98 0 0 1-.275-.715q0-.435.276-.715a.94.94 0 0 1 .702-.281q.426 0 .701.28l17.045 17.37a.98.98 0 0 1 .276.715q0 .435-.276.715a.94.94 0 0 1-.702.281.94.94 0 0 1-.701-.281l-2.407-2.452a8.3 8.3 0 0 1-2.206 1.137 7.8 7.8 0 0 1-2.506.395"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoWater);
export default __webpack_public_path__ + "static/media/no_water.0790e57206de8019cd2446bc9ddd9a69.svg";
export { ForwardRef as ReactComponent };